import {Injectable, Component} from '@angular/core';
import {TimerModel} from "./response/TimerModel";

// @Component({
// selector : "timer",
// template : `<div style="border:true" *ngFor="let item of SummTimer">{{item}}</div>`,
// providers: [CountTimer]

// })
@Injectable()
export class CountTimer {

    LastRequestTime:number;
    constructor() {

    };

    handlerWork() {
        if (this.AllRequestIsWorked) {
            this.LastRequests = this.Requests;
            this.LastRequestTime = this.LastTimeRequests();
            this.Requests = [];
        } else if (this.Requests.length > 0) {
            //
        } else {
            clearInterval(this._intervalId);
        }
    }

    LastTimeRequests(): number {
            let count: number = 0;
            for (let i = 0; i < this.Requests.length; i++) {
                count += this.Requests[i].Ellapsed;
            }
            return count;
    }

    get RenderRequests(): number {
        return window['timer']['elapsed'] as number;
    }

    public Requests: TimerModel[] = [];
    public LastRequests: TimerModel[] = [];
    private _intervalId: number;
    private data: number[] = [];
    private summTimer: number = 0;

    get AllRequestIsWorked(): boolean {
        return this.Requests.length > 0 && this.Requests.filter(x => !x.IsDone).length == 0;
    }

    addData(timer: number) {
        this.data.push(timer);
        var summ = 0;
        for (var i = 0; i < this.data.length; i++)
            summ += this.data[i];
        //
    }

    add(request: TimerModel) {
        this.Requests.push(request);
        this._intervalId = setInterval(this.handlerWork.bind(this), 100);
    }

    getData(): number[] {
        return this.data;
    }

    // ngOnInit() {

    //    for (var i=0;i<this.data.length;i++)
    //    this.summTimer+=this.data[i];
    // }
}